/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_8418a540"]'><div><cube-button @_click="showPicker">basic-picker</cube-button><cube-cascade-picker-modal ref="__mpx_ref_picker__" title="请选择你的组合" content="content 内容" :list="(dataList)" :selected-index="(selectedIndex)" @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @toggle='(e)=>__invoke(e, [["onToggle"]])' @close='(e)=>__invoke(e, [["onClose"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])' @maskClick='(e)=>__invoke(e, [["onMaskClick"]])' @valueChange='(e)=>__invoke(e, [["onValueChange"]])'/><div :class='["demo-data"]' v-if="(confirmParams.length || valueChangeParams.length)"><div :class='["key"]'>其他事件可打开控制台查看输出</div><template v-if="(confirmParams.length)"><div :class='["key"]'>confirmParams 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (confirmParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template><template v-if="(valueChangeParams.length)"><div :class='["key"]'>valueChange 事件触发次数：{{ valueChangeCount }}</div><div :class='["key"]'>valueChangeParams 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (valueChangeParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_8418a540"}'>
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_8418a540"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_8418a540"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker8418a540%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker8418a540%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_8418a540"],
    ctorType: "component",
    outputPath: "components/basic-picker8418a540/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-cascade-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/cascade-picker-modal/index.mpx?isComponent&outputPath=components%2Findex0361f5ae%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>